import { ServiceTypes } from 'constants/ServiceTypes';
import wizardLine from 'images/Wizard/wizardLine.png';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import WizardStore from 'stores/WizardStore';
import { WizardStep } from './WizardStep';
import WizardSteps from './WizardSteps';
import { StyledElement, StyledSection } from './styles/WizardStyles';

export const Wizard: React.FC = observer(() => {
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);

  if (
    wizardStore.currentStep === WizardSteps.Introduction ||
    wizardStore.currentStep === WizardSteps.CleanHomeplate ||
    wizardStore.currentStep === WizardSteps.CorrectPitching
  ) {
    return (
      <StyledSection>
        <WizardStep step={WizardSteps.Introduction} currentStep={wizardStore.currentStep} />
        <StyledElement src={wizardLine} />
        <WizardStep step={WizardSteps.CleanHomeplate} currentStep={wizardStore.currentStep} />
        <StyledElement src={wizardLine} />
        <WizardStep step={WizardSteps.CorrectPitching} currentStep={wizardStore.currentStep} />
      </StyledSection>
    );
  }

  return <></>;
});
